import React, { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

/* وضع النهار والليل للسيستم كله.
   الاختيار بيتحفظ على الجهاز نفسه (localStorage 'theme': 'light' | 'dark')، ولو ماتختارش حاجة بيمشي على إعداد الجهاز.
   الألوان نفسها في tailwind.config.js (متغيرات بتتغير مع html.dark). */

const KEY = 'theme';
const EVENT = 'nesr-theme-change';

const read = () => { try { return localStorage.getItem(KEY); } catch { return null; } };
const systemDark = () => typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

export const isDarkTheme = () => {
  const t = read();
  return t === 'dark' || (t !== 'light' && systemDark());
};

function apply(dark, animate) {
  const root = document.documentElement;
  if (animate) {
    root.classList.add('theme-switching');
    setTimeout(() => root.classList.remove('theme-switching'), 300);
  }
  root.classList.toggle('dark', dark);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', dark ? '#0a1222' : '#0f1d3d');
}

export function setDarkTheme(dark) {
  try { localStorage.setItem(KEY, dark ? 'dark' : 'light'); } catch {}
  apply(dark, true);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: dark }));
}

export function initTheme() {
  apply(isDarkTheme(), false);
  if (window.matchMedia) {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => { if (!read()) { apply(mq.matches, true); window.dispatchEvent(new CustomEvent(EVENT, { detail: mq.matches })); } };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
  }
  /* لو اتغير من تاب تاني */
  window.addEventListener('storage', (e) => { if (e.key === KEY) { apply(isDarkTheme(), true); window.dispatchEvent(new CustomEvent(EVENT, { detail: isDarkTheme() })); } });
}

export function useDarkTheme() {
  const [dark, setDark] = useState(isDarkTheme);
  useEffect(() => {
    const on = (e) => setDark(!!e.detail);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return [dark, (v) => setDarkTheme(typeof v === 'function' ? v(isDarkTheme()) : v)];
}

/* زرار التبديل */
export function ThemeToggle({ className = '', withLabel = false }) {
  const [dark, setDark] = useDarkTheme();
  const label = dark ? 'الوضع النهاري' : 'الوضع الليلي';
  return (
    <button
      type="button"
      onClick={() => setDark(!dark)}
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white text-gray-700 hover:border-gold-400 hover:text-gold-600 transition-colors ${withLabel ? 'px-3 h-10 text-sm font-semibold' : 'w-10 h-10'} ${className}`}
    >
      {dark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
      {withLabel && <span>{label}</span>}
    </button>
  );
}
